import { GroupPointRanking } from './GroupPointRanking';

/**
 * Class representing a container point ranking.
 * @extends GroupPointRanking
 */
export class ContainerPointRanking extends GroupPointRanking {}
